import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "title !mb-0" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Claim your ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" CAMPUS airdrop ")
const _hoisted_4 = { class: "text-neutral-50 text-base text-center" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Each ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" NFT has a twin NFT version, the ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" CAMPUS NFT, that showcases every 250 renders on a screen inside of the CAMPUS environment with four unknown locations. To be eligible for the ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" CAMPUS airdrop you have to buy a ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" NFT of the collection drop on Foundation. After the drop reveal you can connect your wallet that holds ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" NFT(s) to claim your CAMPUS airdrop ")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "block" }, "Claim Campus Airdrop", -1)

import AppButton from "@/components/app/AppButton.vue";
import ImageCenteredSection from "@/components/section/ImageCenteredSection.vue";
import DripversityIcon from "@/components/icons/DripversityIcon.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeCtaAirdrop',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ImageCenteredSection, {
    id: 'cta-airdrop',
    src: require('@/assets/images/campus-unrevealed.gif'),
    alt: 'Claim Campus Airdrop',
    gradient: false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("h2", _hoisted_1, [
          _hoisted_2,
          _createVNode(DripversityIcon, { class: "text-dripversity w-52" }),
          _hoisted_3
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("p", _hoisted_4, [
          _hoisted_5,
          _createVNode(DripversityIcon, { class: "text-dripversity" }),
          _hoisted_6,
          _createVNode(DripversityIcon, { class: "text-dripversity" }),
          _hoisted_7,
          _createVNode(DripversityIcon, { class: "text-dripversity" }),
          _hoisted_8,
          _createVNode(DripversityIcon, { class: "text-dripversity" }),
          _hoisted_9,
          _createVNode(DripversityIcon, { class: "text-dripversity" }),
          _hoisted_10
        ])
      ]),
      _createElementVNode("div", null, [
        _createVNode(AppButton, {
          to: "/airdrop",
          color: "secondary"
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["src"]))
}
}

})